import {
  SearchableVendorTaxonomyKey,
  VendorTaxonomyKey,
} from '@zola-helpers/client/dist/es/marketplace';

import { addSuccessToastToSessionStorageAndReload } from '~/components/common/modals/MiniQuizModal/showMiniQuizModal';

import { QuizCardView } from '../SearchResults/types/types';
import { BudgetQuizCard } from './BudgetQuizCard/BudgetQuizCard';
import { MiniQuizCard } from './MiniQuizCard/MiniQuizCard';
import { isBudgetQuizCardView } from './utils';

export const QuizCard = ({
  card,
  taxonomyKey,
}: {
  card: QuizCardView;
  taxonomyKey: VendorTaxonomyKey;
}) => {
  if (isBudgetQuizCardView(card)) {
    return <BudgetQuizCard noBorder />;
  }

  return (
    <MiniQuizCard
      taxonomyKey={taxonomyKey as SearchableVendorTaxonomyKey}
      noBorder
      onQuizSubmitted={addSuccessToastToSessionStorageAndReload}
    />
  );
};
